export default __webpack_public_path__ + "static/es6-6dc9be228d018d0cd34bb38de5a22aa7.png";